import {CustomTextField} from "../CustomTextField";
import React, { FC } from "react";
import {IDateField as IProps} from "./types";
import cls from '../atoms.module.scss'

const DateField: FC<IProps> = ({
    item,
    index,
    savedFormData,
    handleChange,
}) => (
    <div key={index} className={cls["signUp-position-relative"]}>
        <div className={`${cls["form-group"]} col-12 ${cls["input-paddings"]}`} style={{ padding: "0px", marginBottom: "0px" }}>
            <CustomTextField
                handleChange={(e) => handleChange(e, item.validation)}
                name={item.attribute_code}
                label={item.default_label}
                value={item.default_label}
                inpValue={savedFormData?.[item.attribute_code]}
                required={item.is_required}
                type="date"
                custom={true}
            />
        </div>
    </div>
)

export default DateField;